import { breadcrumb, reportError } from '../observability/errorReporter';

const TAG = '[VoiceCall]';

/** Из SDP: краткая сводка по аудио/видео payload types (отладка iOS↔Android↔web). */
export function sdpCodecSummary(sdp: string): string {
  const lines = sdp.split(/\r?\n/);
  const audio = lines.filter((l) => l.startsWith('a=rtpmap:'));
  const max = 12;
  const head = audio.slice(0, max).join(' | ');
  return audio.length > max ? `${head} …(+${audio.length - max})` : head || '(no rtpmap lines)';
}

/** Из JSON ICE-кандидата или строки candidate — typ host|srflx|relay|prflx. */
export function iceTypFromPayload(candidateField: string): string | null {
  let line = candidateField;
  try {
    const o = JSON.parse(candidateField) as { candidate?: string };
    if (typeof o?.candidate === 'string') line = o.candidate;
  } catch {
    /* treat as raw candidate line */
  }
  const m = /\btyp\s+(\S+)/i.exec(line);
  return m ? m[1] : null;
}

export function voiceCallLog(message: string, ...extra: unknown[]): void {
  if (!__DEV__) return;
  if (extra.length) console.log(TAG, message, ...extra);
  else console.log(TAG, message);
}

/**
 * Что-то в звонке пошло не так, но разговор продолжается: не применился кандидат, не удался
 * рестарт ICE, не переключилась камера.
 *
 * <p>Раньше отсюда был выход только в консоль, и только в отладочной сборке — то есть в релизе
 * тридцать мест, каждое из которых объясняет «звонок не работает», не оставляли ровно ничего.
 * Теперь шаг остаётся всегда (OBS-2): сам по себе он никуда не отправляется, но приезжает вместе
 * с первой же настоящей поломкой и объясняет, что ей предшествовало.
 */
export function voiceCallWarn(message: string, ...extra: unknown[]): void {
  breadcrumb('call', message);
  if (!__DEV__) return;
  if (extra.length) console.warn(TAG, message, ...extra);
  else console.warn(TAG, message);
}

/**
 * Звонок не состоялся или оборвался — это уже отчёт, а не шаг.
 *
 * <p>Уровень `warning`: сорванный звонок — беда пользователя, но не поломка сервера, и поднимать
 * телеграм-бота на каждый обрыв связи нельзя, иначе оповещения перестанут читать (SEC-12).
 * Разбирается это по журналу, где рядом лягут шаги, приведшие к обрыву.
 */
export function voiceCallFailed(
  reason: string,
  error?: unknown,
  context?: Record<string, string | number | boolean | null | undefined>,
): void {
  voiceCallWarn(reason, error);
  void reportError('call', error ?? new Error(reason), {
    level: 'warning',
    context: { причина: reason, ...context },
  });
}
